import {http} from "@/plugins/http";
import {FraudCase} from "@/model/fraud-case";
import {Page} from "@/model/page";
import {CriteriaType} from "@/model/filter-criteria";

export const fraudCaseService = new class FraudCaseService {

  get path (): string {
    return '/fraud-case';
  }

  async getFraudCases (page: number , size: number, msisdn = '', userId = '', creditCardToken = '', paypalPayerId = ''): Promise<Page<FraudCase>> {
    const params = {
      page: page,
      size: size,
      msisdn: msisdn,
      userId: userId,
      creditCardToken: creditCardToken,
      paypalPayerId: paypalPayerId
    };
    return (await http.get(this.path + '/', {
      params
    })).data;
  }

  async getExpand (id: number, get: CriteriaType, relatedTo: CriteriaType, startDate: string, orderUsd: number): Promise<any> {
    return (await http.get(this.path + `/${id}/related`, {
      params: {
        get: get.key,
        relatedTo: relatedTo.key,
        startDate: startDate,
        orderUsd: orderUsd
      }
    })).data;
  }

  async postExpand (id: number, get: CriteriaType,
                    relatedTo: CriteriaType,
                    startDate: string,
                    orderUsd: number,
                    whyAdded: string,
                    whyPardoned: string,
                    pardoned: boolean): Promise<any> {
    return (await http.post(this.path + `/${id}/related`, {
      whyAdded: whyAdded,
      whyPardoned: whyPardoned,
      pardoned: pardoned
    }, {
      params: {
        get: get.key,
        relatedTo: relatedTo.key,
        startDate: startDate,
        orderUsd: orderUsd
      }
    })).data;
  }

  async createFraudCase(hasChargebacks: boolean, hasStolenCards: boolean, blacklisted: boolean, blacklistTransactionId: number, blacklistComment: string): Promise<any> {
    return (await http.post(this.path + '/new', {
      hasChargebacks: hasChargebacks,
      hasStolenCards: hasStolenCards,
      blacklisted: blacklisted,
      blacklistTransactionId: blacklistTransactionId,
      blacklistComment: blacklistComment
    })).data;
  }

  async getFraudCaseById (id: number | string): Promise<FraudCase> {
    return (await http.get(this.path + `/${id}`)).data;
  }

  async addFraudCaseItem (fraudCaseId: number, value: string, type: FraudCaseType, pardoned: boolean, whyAdded: string, whyPardoned: string): Promise<FraudCase> {
    return (await http.post(this.path + `/${fraudCaseId}`, {
      type: type,
      value: value,
      pardoned: pardoned,
      whyAdded: whyAdded,
      whyPardoned: whyPardoned
    })).data;
  }

  async updatePardoned (fraudCaseId: number, value: string, type: FraudCaseType, pardoned: boolean, whyPardoned: string): Promise<FraudCase> {
    return (await http.put(this.path + `/`, {
      id: fraudCaseId,
      value: value,
      pardoned: pardoned,
      type: type,
      whyPardoned: whyPardoned
    })).data;
  }
}

export enum FraudCaseType {
  CREDIT_CARD = "CREDIT_CARD",
  PAYPAL = "PAYPAL",
  USER = "USER",
  MSISDN = "MSISDN"
}
